/**
 * useServiceWorker — wraps vite-plugin-pwa's register hook
 *
 * Exposes needRefresh state and updateServiceWorker action
 * for use with the UpdatePrompt component.
 *
 * Polls for new service worker versions every 15 minutes so users
 * who keep the app open will still see the update prompt.
 */
import { useRegisterSW } from 'virtual:pwa-register/react';
import { createLogger } from '../utils/logger';

const log = createLogger('serviceWorker');

const SW_CHECK_INTERVAL = 15 * 60 * 1000; // 15 minutes

const useServiceWorker = () => {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      log.info('Service worker registered', { swUrl });
      if (registration) {
        setInterval(() => {
          registration.update().catch((err) => {
            log.warn('Service worker update check failed', { error: err.message });
          });
        }, SW_CHECK_INTERVAL);
      }
    },
    onRegisterError(error) {
      log.error('Service worker registration failed', { error: error.message });
    },
  });

  return { needRefresh, updateServiceWorker };
};

export default useServiceWorker;
